import { Input } from "reactstrap";
import { formatCellValue ,formatDateForDisplay} from "../../../Utils/UtilityFunctions";
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../Utils/UtilityFunctions';

export const uomColoumns = (selectAllUoms, setSelectAllUoms, uom, setSelectedUom, selectedUom, checkboxRef, isMobile) => {

      const rawPermissions = useSelector(
              (state) => state.permissions.permissionsMap
          );
      
          const permissionsMap = new Map(
              rawPermissions.map(([key, value]) => [key, new Set(value)])
          );
          const uomInventoryPermission = hasPermission(permissionsMap, "configuration", "uom")
  
      const uomLabel = uomInventoryPermission?.has("list") ? "Unit" : "UOM";

  const columns = [
    {
      accessorKey: 'checkbox',
      header: 'checkbox',
      muiTableHeadCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      muiTableBodyCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
      Header: ({ row }) => (
        <Input readOnly type="checkbox" ref={checkboxRef} className='rv-table-checkbox' checked={selectAllUoms} style={{ borderWidth: '2px', borderColor: '#838383', borderRadius: '0' }} onClick={() => {
          setSelectAllUoms(!selectAllUoms)
          if (!selectAllUoms) {
            setSelectedUom(uom)
          }
          else {
            setSelectedUom([])
          }
        }} />
      ),
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnDragging: false,
      Cell: ({ row }) => (
        <Input readOnly type="checkbox" className='rv-table-checkbox' checked={selectedUom.some(p => p.name === row.original.name)} style={{ borderWidth: '2px', borderColor: '#838383', borderRadius: '0' }} onClick={() => {
          handleCheckboxChange(row, selectedUom, setSelectedUom)
        }
        } />
      ),
      size: isMobile ? 50 : 7
    },
    {
      accessorKey: 'name',
      header: `${uomLabel} Name`,
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'valueType',
      header: 'Value Type',
      Cell: ({ cell }) => cell.getValue() === "bool" ? 'Boolean' : cell.getValue() === "float64" ? "Decimal" : cell.getValue() === "string" ? "Text" : cell.row.original.valueType[0].toUpperCase() + cell.row.original.valueType.slice(1)
    },
    {
      accessorKey: 'stepQuantity',
      header: 'Step Quantity',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
  ];

  return columns;
};

export const handleCheckboxChange = (row, selectedUom, setSelectedUom) => {
  let isChecked = selectedUom.some(p => p.name === row.original.name);
  let updatedSelectedUoms = isChecked
    ? selectedUom.filter(p => p.name !== row.original.name)
    : [...selectedUom, row.original];
  setSelectedUom(updatedSelectedUoms);
};

// export const capitalize = (uom) => {
//   if(uom?.length > 2)
//     return String(uom).charAt(0).toUpperCase() + String(uom).slice(1).toLowerCase();
//   else  
//     return uom
// }